import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { SvgComponent } from 'icon';
import { ProductCardBulletListComponent } from '../product-card-bullet-list/product-card-bullet-list.component';

@Component({
  selector: 'lib-product-card-bullet-list-item',
  imports: [CommonModule, SvgComponent],
  templateUrl: './product-card-bullet-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardBulletListItemComponent {
  public brand = inject(ProductCardBulletListComponent, { host: true }).brand;
  public isOfferBox = input(true);
}
